import { axiosRef } from '.';
import { AddUserDto } from '../types';

export const loginService = (payload: any) =>
  axiosRef.post(`/auth/token`, payload);

export const signUpService = (payload: any) =>
  axiosRef.post(`/sign-up`, payload);

export const confirmEmailService = (payload: any) =>
  axiosRef.post(`/confirm-email`, payload);

export const resendConfirmEmailService = (payload: any) =>
  axiosRef.put(`/users/${payload.username}/user_resend_confirm_email`, payload);

export const loginRefreshToken = (payload: any) =>
  axiosRef.post(`/auth/token/refresh`, payload);

export const getUserInfo = (email: string) => axiosRef.get(`/users/${email}`);

export const updateUserInfo = (email: string, payload: AddUserDto) =>
  axiosRef.put(`/users/${email}`, payload);

export const changePassword = (email: string, payload: any) =>
  axiosRef.put(`/users/${email}/change_password`, payload);

export const fetchUsersList = (payload?: any) => {
  let url = `/users?`;
  if (payload && payload.page_size) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_active) {
    url = url + `is_active=${payload.is_active}&`;
  }
  if (payload && payload.is_vendor) {
    url = url + `is_vendor=${payload.is_vendor}&`;
  }
  if (payload && payload.is_pharma) {
    url = url + `is_pharma=${payload.is_pharma}&`;
  }
  if (payload && payload.is_dangerous_goods) {
    url = url + `is_dangerous_goods=${payload.is_dangerous_goods}&`;
  }
  if (payload && payload.is_payment) {
    url = url + `is_payment=${payload.is_payment}&`;
  }
  return axiosRef.get(url);
};
